"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesCountryListCtl = /** @class */ (function (_super) {
    __extends(AffilatesCountryListCtl, _super);
    function AffilatesCountryListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_country_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_id; });
        _this.dk_app_country_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_title; });
        _this.dk_app_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_code; });
        _this.dk_is_default = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_default; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesCountryListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AffilatesCountryListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AffilatesCountryListCtl.prototype.LoadData = function (pprogramId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramAppCountryByPProgramIdGet.exec({ pprogram_id: pprogramId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_country_id: resp.list[i].app_country_id,
                    app_country_title: resp.list[i].app_country_title,
                    app_country_code: resp.list[i].app_country_code,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_default: resp.list[i].is_default
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesCountryListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramAppCountry.exec({
            data: {
                app_country_id: data.app_country_id,
                pprogram_id: data.pprogram_id,
                is_default: data.is_default
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_country_id: data.app_country_id,
                app_country_title: resp.app_country_title,
                app_country_code: resp.app_country_code,
                is_default: data.is_default,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*public EditData(data: IEditAppCountryItem, onDone?: () => void) {
        let _tmp = this.getById(data.key);
        if (_tmp) {
            DoEditPProgramAppCountry.exec({
                data: {

                    pprogram_app_country_id: data.key,
                    app_country_id: data.app_country_id,
                    is_default: data.is_default
                }
            }, (resp: DoEditPProgramAppCountryResponse) => {

                _tmp.app_country_id = data.app_country_id;
                _tmp.app_country_title = resp.app_country_title;
                _tmp.app_country_code = resp.app_country_code;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_default = data.is_default;

                this.Update();
                if (onDone) {
                    onDone();
                }

            }, (err) => {
                this._errDialog.ShowApiError(err);
            });
        }
    }*/
    AffilatesCountryListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesCountryListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramAppCountry.exec({
                data: {
                    pprogram_app_country_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesCountryListCtl.prototype.DoSetIsDefault = function (key, isDefault, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramAppCountryIsDefault.exec({ data: { pprogram_app_country_id: key, is_default: isDefault } }, function (resp) {
                _tmp.is_default = isDefault;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesCountryListCtl;
}(BaseController_1.BaseController));
exports.AffilatesCountryListCtl = AffilatesCountryListCtl;
/*export interface IEditAppCountryItem {

    key: number;
    app_country_id: number;
    is_default: boolean;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesCountryListCtl.ts
// module id = 990
// module chunks = 0